import React, { useState } from 'react';
import Select from 'react-select';

function ErrorSelecter({ errorScore, setErrorScore }) {
    const [selectedOption, setSelectedOption] = useState(null);

    const handleErrorChange = (selectedOption) => {
        setSelectedOption(selectedOption);
        if (selectedOption) {
            setErrorScore(selectedOption.value);
        }
    };

    const options = [
        { value: 1, label: '誤りスコア1' },
        { value: 2, label: '誤りスコア2' },
        { value: 3, label: '誤りスコア3' },
        { value: 4, label: '誤りスコア4' },
        { value: 5, label: '誤りスコア5' },
        { value: 6, label: '誤りスコア6' },
        { value: 7, label: '誤りスコア7' },
        { value: 8, label: '誤りスコア8' },
    ];

    return (
        <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">
                誤りスコアを選択してください
            </label>
            <Select
                value={selectedOption}
                onChange={handleErrorChange}
                options={options}
                placeholder="誤りスコアを選択"
            />
        </div>
    );
}

export default ErrorSelecter;